import { useState } from 'react';

import { RowContextMenuProvider } from './RowProvider.context';
import { RowContextValue } from './rowContext.types';

const RowProvider = ({ children }: { children: React.ReactNode }) => {
  const [contextMenuInfo, setContextMenuInfo] = useState<RowContextValue['contextMenuInfo']>({
    x: undefined,
    y: undefined,
  });
  const [isOpenedViaContextMenu, setIsOpenedViaContextMenu] =
    useState<RowContextValue['isOpenedViaContextMenu']>(false);
  return (
    <RowContextMenuProvider
      value={{
        contextMenuInfo,
        setContextMenuInfo,
        isOpenedViaContextMenu,
        setIsOpenedViaContextMenu,
      }}
    >
      {children}
    </RowContextMenuProvider>
  );
};

export { RowProvider };
